import { Avatar, Box, CardContent, Grid, Typography } from '@mui/material';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import { formatAmount } from 'utils/helpers';
import SwitchButton from 'components/Common/SwitchButton';
import BusinessCardSkeleton from 'components/Skeleton/BusinessCardSkeleton';
interface BankAccountCardTypes {
    accountNumber?: string | number;
    accountType?: string;
    balance?: string | number;
    bankCardDetails?: any;
    getContainerLoading: boolean;
    handleChangeSwitch: (value: any) => void;
}

const BankAccountCard = ({ bankCardDetails, handleChangeSwitch, getContainerLoading }: BankAccountCardTypes) => {
    const { balance, detail } = bankCardDetails || {};
    return (
        <>
            {getContainerLoading ? (
                <BusinessCardSkeleton />
            ) : (
                <Box alignItems={'center'} mt={10} width={'70%'}>
                    <CardContent sx={{ borderWidth: 2 }}>
                        <Grid container spacing={2} alignItems="center" sx={{ backgroundColor: '#F9FAFB' }}>
                            <Grid item>
                                <Avatar sx={{ bgcolor: 'blue' }}>
                                    <CreditCardIcon />
                                </Avatar>
                            </Grid>
                            <Grid item alignItems={'center'}>
                                <Typography variant="h5" component="div">
                                    {`Checking Account**** ${detail?.last4AccountDigits}`}
                                </Typography>
                                <Typography variant="body1" component="div">
                                    Available Balance: {formatAmount(balance?.availableBalance, 'cents')}
                                </Typography>
                            </Grid>
                        </Grid>
                    </CardContent>
                    <Grid container sx={{ mb: 8 }}>
                        <Grid
                            item
                            display={'flex'}
                            flexDirection={'row'}
                            justifyContent={'space-between'}
                            alignItems={'center'}
                            width={'fit-content'}
                        >
                            <Typography variant="body1" component="div">
                                Set as active account
                            </Typography>
                            <SwitchButton
                                disabled={detail?.default}
                                checked={detail?.default}
                                onChange={() => handleChangeSwitch(balance?.moneyContainerId)}
                            />
                        </Grid>
                    </Grid>
                </Box>
            )}
        </>
    );
};

export default BankAccountCard;
